<template>
    <div>
        <el-checkbox 
            :id="name" 
            :name="name" 
            :value="value" 
            :disabled="disabled"
            :required="required"
            @change="onChange">
            <slot>{{ name }}</slot>{{ required ? ' *' : '' }}
        </el-checkbox>

        <div v-if="hasErrors" class="form-group__errors">
            <p>{{ errors[0] }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SaxxCheckbox',
    props: {
        form: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String
        },
        required: {
          required: false,
          type: Boolean,
          default: false
        },
    },
    computed: {
        ...mapGetters('forms', [
            'getField',
            'getErrors',
            'getFieldIsDisabled',
        ]),
        value() {
            return this.getField({
                form: this.form,
                field: this.name,
            });
        },
        errors() {
            return this.getErrors({
                form: this.form,
                field: this.name,
            });
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        disabled() {
            return this.getFieldIsDisabled({ form: this.form, field: this.name });
        },
    },
    methods: {
        ...mapActions('forms', [
            'setField',
        ]),
        onChange(value) {
            this.setField({
                form: this.form,
                field: this.name,
                value,
            });
        },
    },
}
</script>
